import { faCheckCircle } from "@fortawesome/pro-regular-svg-icons/faCheckCircle";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconCheckCircle: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faCheckCircle} />;
};
